<template>
  <page-outline :title="$t('suppliers.add_note')">
    <template slot="pageContent">
      <b-container>
        <back-button class="mb-4"></back-button>
        <b-row>
          <b-col md="4" class="form-group">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('common.title')"
              type="text"
              v-model="title">
            </form-write-group-label-input>
          </b-col>
          <b-col md="12" class="form-group">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('common.comment_label')"
              type="text"
              v-model="note">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-col cols="2" offset="10" class="form-group mt-3">
          <b-button variant="primary"
            @click="saveNote()">
            {{ $t('common.sve') }}
          </b-button>
        </b-col>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'
import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'AddNote',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  props: {
  },
  data () {
    return {
      title: '',
      note: '',
      siren: ''
    }
  },
  created () {
    this.siren = this.$engine.services.suppliers.selectedSupplier.Siren
  },
  methods: {
    saveNote () {
      let that = this
      that.$engine.services.suppliers.createCustomData(
        this.title,
        this.note,
        this.siren
      ).then(resp => {
        that.$f7.modal({
          title: this.$i18n.t('suppliers.added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                loadPage(that, {url: '/kycform/'})
              }
            }
          ]
        })
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
        let that = this
        that.$f7.modal({
          title: this.$i18n.t('acceptance.error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    }
  }
}

</script>
